import styled from 'styled-components';

export const StyledMap = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    display: ${({ hide }) => hide ? 'none' : 'block'};
`;